module.exports = __webpack_public_path__ + "img/patents.f7ee751a.png";